import { Component } from "@theme/component";
import { MediaStartedPlayingEvent } from "@theme/events";

class TiktokPopupContent extends Component {
  constructor() {
    super();
    this.loadContent = this.loadContent.bind(this);
  }

  connectedCallback() {
    this.dialog = this.closest("dialog-component");
    if (!this.dialog) return;

    this.dialog.addEventListener("dialog:open", this.loadContent);
  }

  async loadContent() {
    const tiktokUrl = this.dialog.dataset.tiktokUrl;
    if (!tiktokUrl) {
      console.error("No TikTok URL provided");
      return;
    }

    this.dispatchEvent(new MediaStartedPlayingEvent(this));
    const innerContainer = this.querySelector(".tiktok-popup__inner");

    if (!innerContainer) {
      console.error("No inner container found");
      return;
    }
    try {
      // Fetch embed code from TikTok oEmbed API
      const oembedUrl = `https://www.tiktok.com/oembed?url=${encodeURIComponent(
        tiktokUrl
      )}`;
      const response = await fetch(oembedUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch TikTok embed: ${response.statusText}`);
      }

      const data = await response.json();
      if (!data.embed_product_id) {
        throw new Error("No embed HTML returned from TikTok API");
      }

      const videoId = data.embed_product_id;

      innerContainer.innerHTML = `
<iframe frameborder="0"
  sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-top-navigation allow-same-origin"
  src="https://www.tiktok.com/embed/v2/${videoId}?rel=0" allow="fullscreen">
</iframe>
`;

      this.setAttribute("data-media-loaded", "true");
    } catch (error) {
      console.error("Error loading TikTok embed:", error);

      // Show error message to user

      innerContainer.innerHTML = `
          <div style="padding: 2rem; text-align: center;">
            <p>Unable to load TikTok video.</p>
          </div>
        `;
    }
  }
}

if (!customElements.get("tiktok-popup-content")) {
  customElements.define("tiktok-popup-content", TiktokPopupContent);
}
